import { instanceBo } from "../utils/axios.create";
import { CupResponse, CupsResponse, CupStatus } from "@/domain/cup.interface";

export interface CupRequest {
	accountId: string;
	name: string;
	vendor: string;
	display: string;
	description: string;
	status: CupStatus;
	analytes?: string[];
	createdBy: string;
}

export interface CupUpdateRequest extends Omit<CupRequest, "createdBy"> {
	_id: string;
	updatedBy: string;
}

export interface CupSearchParams {
	search?: string;
	name?: string;
	vendor?: string;
	accountId?: string;
}

const getCups = async (): Promise<CupsResponse> => {
	return instanceBo
		.get("/cups")
		.then((res) => res.data)
		.catch((err) => {
			return Promise.reject(err.response?.data || err);
		});
};

const getCupById = async (id: string): Promise<CupResponse> => {
	return instanceBo
		.get(`/cups/${id}`)
		.then((res) => res.data.body)
		.catch((err) => {
			return Promise.reject(err.response?.data || err);
		});
};

const searchCups = async (params: CupSearchParams): Promise<CupsResponse> => {
	const queryParams = new URLSearchParams();

	if (params.search) queryParams.append("search", params.search);
	if (params.name) queryParams.append("name", params.name);
	if (params.vendor) queryParams.append("vendor", params.vendor);
	if (params.accountId) queryParams.append("accountId", params.accountId);

	const queryString = queryParams.toString();
	const url = `/cups${queryString ? `?${queryString}` : ""}`;

	return instanceBo
		.get(url)
		.then((res) => res.data)
		.catch((err) => {
			return Promise.reject(err.response?.data || err);
		});
};

const createCup = async (data: CupRequest): Promise<CupResponse> => {
	return instanceBo
		.post("/cups", data)
		.then((res) => res.data.body)
		.catch((err) => {
			return Promise.reject(err.response?.data || err);
		});
};

const updateCup = async (data: CupUpdateRequest): Promise<CupResponse> => {
	const { _id, ...updateData } = data;
	return instanceBo
		.put(`/cups/${_id}`, updateData)
		.then((res) => res.data.body)
		.catch((err) => {
			return Promise.reject(err.response?.data || err);
		});
};

const deleteCup = async (id: string): Promise<void> => {
	return instanceBo
		.delete(`/cups/${id}`)
		.then((res) => res.data)
		.catch((err) => {
			return Promise.reject(err.response?.data || err);
		});
};

export const cupService = {
	getCups,
	getCupById,
	searchCups,
	createCup,
	updateCup,
	deleteCup,
};
